var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 mt-2 px-6 gap-2"},_vm._l((_vm.items),function(item){return _c('QrCode',{key:item.qr_id,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }